/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  addEncoderSizePrefix,
  addDecoderSizePrefix,
  getStructDecoder,
  getStructEncoder,
  getU32Decoder,
  getU32Encoder,
  getUtf8Decoder,
  getUtf8Encoder,
  type Codec,
  type Decoder,
  type Encoder,
} from "@solana/kit";

/** Rule condition (placeholder) */
export type RuleCondition = {
  /** Condition expression */
  expression: string;
};

export type RuleConditionArgs = {
  /** Condition expression */
  expression: string;
};

export function getRuleConditionEncoder(): Encoder<RuleConditionArgs> {
  return getStructEncoder([
    ["expression", addEncoderSizePrefix(getUtf8Encoder(), getU32Encoder())],
  ]);
}

export function getRuleConditionDecoder(): Decoder<RuleCondition> {
  return getStructDecoder([
    ["expression", addDecoderSizePrefix(getUtf8Decoder(), getU32Decoder())],
  ]);
}

export function getRuleConditionCodec(): Codec<RuleConditionArgs, RuleCondition> {
  return combineCodec(getRuleConditionEncoder(), getRuleConditionDecoder());
}
